import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../theme/ThemeProvider";

export const ModeToggle = () => {
  const { mode, toggleMode } = useTheme();
  return (
    <button
      onClick={toggleMode}
      data-testid="mode-toggle-button"
      aria-label={`Switch to ${mode === "dark" ? "light" : "dark"} mode`}
      className="relative w-9 h-9 flex items-center justify-center rounded-full border border-border-dim text-text-muted hover:text-theme-primary hover:border-theme-primary/50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-primary"
    >
      {mode === "dark" ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
};
